import _regeneratorRuntime from "babel-runtime/regenerator";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";

export default {
  props: ["property", "resident"],
  data: function data() {
    return {
      isDelete: window.validator.can(["delete-resident", "delete-all"]),
      headers: ["First Name", "Last Name", "Unit", {
        title: "Lease Expires",
        filter: "dateFull"
      }, {
        title: "Move In Date",
        filter: "dateFull"
      }, {
        title: "Move Out",
        filter: "dateFull"
      }, {
        title: "Ledger Balance",
        filter: "toCurrency"
      }],
      fields: ["full_first_name", "person.last_name", "unit.unit_label", // should really be `latest_lease.unit.unit_label` but not handling; this will work
      "latest_lease.lease_expiration_date", "latest_move_in_event.movein_date", "move_out_date", "ledger.balance"],
      fieldCriteria: {
        value: 'Notice',
        field: 'current_status',
        class: 'warning-icon'
      },
      monthLoading: true,
      searchFields: ["full_first_name", "name"],
      approvalLoading: true,
      stageLoading: true,
      conversionChartData: [["Opened", 0], ["Archived", 0]],
      sourceChartData: [["Facebook", 0], ["Google.com", 0], ["Apartment Guide", 0]],
      monthlyChartData: [["Jan", 0], ["Feb", 0], ["Mar", 0], ["Apr", 0], ["May", 0], ["Jun", 0], ["Jul", 0], ["Aug", 0], ["Sep", 0], ["Oct", 0], ["Nov", 0], ["Dec", 0]],
      totalRecord: 0
    };
  },
  created: function created() {
    var _this = this;

    Event.$on("resident-list-dashboard-updated", this.refresh);
    Event.$on("remove-resident", this.removeResident);
    Event.$on("delete-entry", function (item) {
      _this.refresh();
      _this.$snotify.success("The resident was deleted");
    });
    Event.$on("show-resident-list", function () {
      return _this.$store.dispatch("getCurrentResidents");
    });
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off("resident-list-dashboard-updated");
    Event.$off("remove-resident");
    Event.$off("delete-entry");
    Event.$off("show-resident-list");
  },
  mounted: function mounted() {},

  methods: {
    removeResident: function removeResident(item) {
      Event.$emit("confirm-delete", item, "/prototype/resident/" + item.id, "delete-entry", "Are you sure you want to Delete this Resident?", "Delete", "", true);
    },
    getMonthlyResidents: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _ref2, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return axios.get("/prototype/properties/" + (this.property || "all") + "/monthly-residents");

              case 3:
                _ref2 = _context.sent;
                data = _ref2.data;

                this.monthlyChartData = this.monthlyChartData.map(function (month) {
                  return [month[0], data[moment().month(month[0]).format("MM")] && data[moment().month(month[0]).format("MM")].length || 0];
                });
                this.monthLoading = false;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function getMonthlyResidents() {
        return _ref.apply(this, arguments);
      }

      return getMonthlyResidents;
    }(),
    refresh: function refresh() {
      this.$store.dispatch("getCurrentResidents");
    }
  },
  computed: {
    residents: function residents() {
      return this.$store.state.currentResidents;
    },
    loading: function loading() {
      return this.$store.state.isLoading;
    },

    sortedArray: function sortedArray() {
      return this.residents.sort(function (a, b) {
        if (!a.unit || !b.unit) return false;
        return a.unit.name - b.unit.name;
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentList.vue
// module id = 2YUv
// module chunks = 0 1